module.exports = {
      id: "cherry-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#cherry",
      toString: function () {
        return this.url;
      }
    }